import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'loader',
  template: `
  <div *ngIf="showBlockTitle" class="ion-padding">
    <h1><ion-skeleton-text [animated]="true" style="width: 80%;"></ion-skeleton-text></h1>
    <h4><ion-skeleton-text [animated]="true" style="width: 60%;"></ion-skeleton-text></h4>
  </div>
  <ion-list-header>
    <ion-skeleton-text [animated]="true" style="width: 80px"></ion-skeleton-text>
  </ion-list-header>
  <ion-item *ngFor="let repeat of [0,1,2,3,4,5]">
    <ion-thumbnail *ngIf="withThumbnail" slot="start">
      <ion-skeleton-text [animated]="true"></ion-skeleton-text>
    </ion-thumbnail>
    <ion-label>
      <h3>
        <ion-skeleton-text [animated]="true" style="width: 80%;"></ion-skeleton-text>
      </h3>
      <p>
        <ion-skeleton-text [animated]="true" style="width: 60%;"></ion-skeleton-text>
      </p>
      <p>
        <ion-skeleton-text [animated]="true" style="width: 30%;"></ion-skeleton-text>
      </p>
    </ion-label>
  </ion-item>
  `,
})
export class LoaderComponent {
  @Input() showBlockTitle = true;
  @Input() withThumbnail = true;
}
